import { CalendarDays } from 'lucide-react';

import { FUND_COST_CATEGORY_LABELS } from '@/types/fund-costs';
import {
  FUND_TRANSACTION_TYPE_LABELS,
  type FundTransactionDetail,
  type ReconciliationStateResponse,
} from '@/types/fund-transactions';
import { formatCurrency, formatDate } from '@/utils/formatters';

import { Field } from './transactionDetails';
import { TransactionDetailsCard } from './TransactionDetailsCard';

/** Derived from the paid cost; nothing to verify. */
export function FundCostRecognitionDetailsCard({
  transaction,
  fundName,
  reconciliation,
  onViewJournalEntries,
}: {
  transaction: FundTransactionDetail;
  fundName: string;
  reconciliation: ReconciliationStateResponse | undefined;
  onViewJournalEntries?: () => void;
}) {
  const snapshot = transaction.fund_cost;

  return (
    <TransactionDetailsCard
      transaction={transaction}
      fundName={fundName}
      reconciliation={reconciliation}
      onViewJournalEntries={onViewJournalEntries}
      icon={<CalendarDays className="h-5 w-5" />}
      iconClassName="bg-sky-100 text-sky-600 dark:bg-sky-950/40 dark:text-sky-300"
      eyebrow={FUND_TRANSACTION_TYPE_LABELS[transaction.transaction_type]}
      fields={
        <>
          <Field label="Amount">
            {formatCurrency(transaction.amount, {
              currency: transaction.currency,
            })}
          </Field>
          {snapshot && (
            <Field label="Month">
              {`${formatDate(snapshot.period_start)} – ${formatDate(snapshot.period_end)}`}
            </Field>
          )}
          {snapshot && (
            <Field label="Category">
              {
                FUND_COST_CATEGORY_LABELS[
                  snapshot.cost_category as keyof typeof FUND_COST_CATEGORY_LABELS
                ]
              }
            </Field>
          )}
        </>
      }
    />
  );
}
